import { LoginForm } from './LoginForm.js';
import type { SessionUser } from '../api/types.js';
import starLogo from '@bqs/templates/assets/brand/STAR_Horizontal_Light.svg';

/**
 * Anmeldebildschirm: Markenflaeche links, Anmeldeformular rechts.
 *
 * Das Logo sitzt auf einer weissen Flaeche innerhalb des blauen Bereichs -- weder
 * die Light- noch die Dark-Variante des Markenpakets ist fuer K+Z-Blau als
 * Untergrund vorgesehen (siehe Kontrastmessung im Kommentar in App.tsx).
 */
export function LoginScreen({
  onLogin,
}: {
  onLogin: (user: SessionUser) => void;
}): React.JSX.Element {
  return (
    <div className="login-screen">
      <div className="login-brand">
        <div className="login-brand-inner">
          <span className="login-logo-card">
            <img
              className="login-logo"
              src={starLogo}
              alt="STAR – Sales Tool for Automated Requests"
            />
          </span>
          <p className="login-product-name">B2B Quote STAR</p>
          <p className="login-product-tagline">Sales Tool for Automated Requests</p>
        </div>
        <p className="login-service-note">Ein Service von Kroll &amp; Ziller</p>
      </div>
      <div className="login-panel">
        <LoginForm onLogin={onLogin} />
      </div>
    </div>
  );
}
